export default __webpack_public_path__ + "static/media/settings_close_icon.8af683ff.svg";